export default "__VITE_ASSET__de67ff82__"